/**
 * Registry defining which columns across modules support free-text partial search filters.
 * Keyed by: [orderType][headerLowerCase]
 */
export const searchFilterConfigByModule = {
  warehouse: {
    state: {
      paramKey: "state__icontains",
      label: "State",
      placeholder: "Search state...",
    },
    address: {
      paramKey: "address__icontains",
      label: "Address",
      placeholder: "Search address...",
    },
    "short description": {
      paramKey: "short_description__icontains",
      label: "Short Description",
      placeholder: "Search short description...",
    },
    "long description": {
      paramKey: "long_description__icontains",
      label: "Long Description",
      placeholder: "Search long description...",
    },
  },
  users: {
    name: {
      paramKey: "name",
      label: "Name",
      placeholder: "Search name or email...",
    },
    email: {
      paramKey: "name",
      label: "Email",
      placeholder: "Search email...",
    },
    company: {
      paramKey: "company_name",
      label: "Company",
      placeholder: "Search company...",
    },
    partner: {
      paramKey: "supplier_name",
      label: "Partner",
      placeholder: "Search partner...",
    },
  },
};

/**
 * Checks if a specific column in a module uses a free-text search filter.
 *
 * @param {string} orderType - Module type (e.g., "warehouse")
 * @param {string} headerLowerCase - Lowercase column header name (e.g., "state")
 * @returns {boolean}
 */
export const isSearchFilterField = (orderType, headerLowerCase) => {
  return Boolean(searchFilterConfigByModule[orderType]?.[headerLowerCase]);
};

/**
 * Retrieves the search filter configuration for a column.
 *
 * @param {string} orderType - Module type (e.g., "warehouse")
 * @param {string} headerLowerCase - Lowercase column header name
 * @returns {object|null}
 */
export const getSearchFilterConfig = (orderType, headerLowerCase) => {
  return searchFilterConfigByModule[orderType]?.[headerLowerCase] || null;
};
